import { defineMessages } from "react-intl";

const messages = defineMessages({
  copyright: {
    id: "apexonline.components.appfooter.copyright",
    defaultMessage: "© 2021 Apex Clearing Corporation",
  },
});

export default messages;
